import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AccountProfile() {
  const { user } = useAuth();
  const [form, setForm] = useState({ name: "", phone: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) setForm({ name: user.name || "", phone: user.phone || "" });
  }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.put("/account/profile", form);
      toast.success("Profile updated");
    } catch { toast.error("Could not save"); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="account-profile">
      <h2 className="font-display text-2xl uppercase tracking-tight">Profile</h2>
      <div className="divider-orange mt-3 mb-6" />
      <form onSubmit={submit} className="max-w-lg space-y-4 border border-white/10 p-6">
        <div>
          <label className="overline block mb-2">Email</label>
          <input data-testid="profile-email" value={user?.email || ""} readOnly disabled className="w-full bg-[#0a0a0a] border border-white/10 px-4 py-3 text-white/40 font-body cursor-not-allowed" />
        </div>
        <div>
          <label className="overline block mb-2">Full Name</label>
          <input data-testid="profile-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-[#111] border border-white/15 px-4 py-3 focus:outline-none focus:border-[#D96A1B] font-body" />
        </div>
        <div>
          <label className="overline block mb-2">Phone</label>
          <input data-testid="profile-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+91 9XXXXXXXXX" className="w-full bg-[#111] border border-white/15 px-4 py-3 focus:outline-none focus:border-[#D96A1B] font-body" />
        </div>
        <button data-testid="profile-save" disabled={loading} className="btn-orange">
          {loading ? "Saving…" : "Save Changes"}
        </button>
      </form>
    </div>
  );
}
